import React, { useState, useEffect, useRef } from "react";
import Header from "../../Common/Layout/Header";
import "flatpickr/dist/themes/material_blue.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../Common/Configurations/AuthContext";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import SightSeeingTabs from "../AllTabs/SightSeeingTabs";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
const SightSeeingProduct = () => {
  const { state } = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [pageLoading, setPageLoading] = useState(false);
  const [productQuery, setProductQuery] = useState({});
  const [searchQuery, setSearchQuery] = useState({});
  const [product, setProduct] = useState({});
  const [inclusions, setInclusions] = useState([]);
  const [exclusions, setExclusions] = useState([]);
  const [itineraries, setItineraries] = useState([]);
  const [informations, setInformations] = useState([]);
  const [cancellations, setCancellations] = useState([]);
  const [productImages, setProductImages] = useState([]);
  const [productPickup, setProductPickup] = useState({});
  const [productTicket, setProductTicket] = useState({});
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  const BindPageData = (productQuery) => {
    setPageLoading(true);
    const formQuery = {
      productId: params.productId,
      supplierId: productQuery?.supplierId,
    };
    GetProduct(formQuery);
  };
  const handleBook = () => {
    const searchQuery = {
      sightSeeingBookingId: "00000000-0000-0000-0000-000000000000",
      userId: user?.id,
      branchId: user?.bId,
      supplierId: product.supplierId,
      bookingNo: "",
      discount: 0,
      couponCode: "",
      supplierBookingId: params.productId,
      productName: productQuery.productName,
      productURL: product.productURL,
      transactionNo: "",
      bookingDate: new Date(),
      noOfAdults: params.adults,
      noOfKids: params.kids,
      travelDate: params.travelDate,
      city: params.destination,
      travellerName: "",
      bookingStatus: "PENDING",
      paymentStatus: "PENDING",
      travellerInfos: [],
      invoiceNo: "",
      transactionFee: 0,
      totalPrice: productQuery.salePrice,
      gst: 0,
      gstAmount: 0,
      paymentGatewayFee: 0,
      markup: 0,
      customerPrice: productQuery.salePrice,
      bookingType: "SIGHTSEEING",
      gatewayAmount: 0,
      walletAmount: 0,
      creditAmount: 0,
      paymentGatewayNo: "",
      paymentGateway: "RAZORPAY",
      email: "",
      mobile: "",
      requestedBy: "CUSTOMER",
      price: productQuery.salePrice,
      currencyCode: productQuery.currencyCode,
    };
    navigate(
      "/sightseeing/booking/" +
        params.productId +
        "/" +
        params.destinationCode +
        "/" +
        params.destination +
        "/" +
        params.adults +
        "/" +
        params.kids +
        "/" +
        params.travelDate,
      { state: { searchQuery, product } }
    );
  };
  const GetProduct = async (searchQuery) => {
    const result = await apiService.post(
      config.SIGHTSEEINGPRODUCT,
      searchQuery
    );
    if (result.succeeded) {
      setProduct(result.data);
      if (result.data !== null) {
        const filteredInclusions = result.data.productInclusions.filter(
          (inclusion) =>
            inclusion.description && inclusion.description.trim() !== ""
        );
        const filteredExclusions = result.data.productExclusions.filter(
          (inclusion) =>
            inclusion.description && inclusion.description.trim() !== ""
        );
        setInclusions(filteredInclusions);
        setExclusions(filteredExclusions);
        setInformations(result.data.productInformation);
        setItineraries(result.data.productItineraries);
        setCancellations(result.data.productCancellationPolicy);
        setProductImages(result.data.productImages);
        setProductPickup(result.data.productPickup);
        setProductTicket(result.data.productTicketInformation);
      }
    }
    setPageLoading(false);
  };
  useEffect(() => {
    if (state === null || state.searchQuery === null) {
      navigate("/sightseeing/search");
    }
    setSearchQuery(state.searchQuery);
    setProductQuery(state.productQuery);
    BindPageData(state.productQuery);
  }, []);
  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }
  return (
    <div id="layout-wrapper">
      <Header />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card pt-0">
              <div className="p-2">
                <SightSeeingTabs pageName="SEARCH" />
              </div>
              <div className="card-body">
                {pageLoading === true ? (
                  <div className="text-center">
                    <img
                      src="/assets/images/loader.webp"
                      width={"64px"}
                      height={"64px"}
                    ></img>
                    Loading, Please wait...
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-lg-8">
                      <div className="bg-white shadow-md rounded p-3 p-sm-4 confirm-details">
                        <h4 className="mb-1">{product.productName}</h4>
                        <div
                          className="owl-carousel owl-theme single-slider mb-3"
                          data-animateout="fadeOut"
                          data-animatein="fadeIn"
                          data-autoplay="true"
                          data-loop="true"
                          data-autoheight="true"
                          data-nav="true"
                          data-items={1}
                        >
                          <Carousel responsive={responsive}>
                            {productImages.length > 0 &&
                              productImages.map((pi) => (
                                <div className="item">
                                  <Link to={pi.imageUrl} target="_blank">
                                    <img
                                      className="img-fluid"
                                      src={pi.imageUrl}
                                      alt="Hotel photo"
                                      style={{ minWidth: "800px" }}
                                    />
                                  </Link>
                                </div>
                              ))}
                          </Carousel>
                        </div>
                        <nav
                          id="navbar-sticky"
                          className="bg-white pb-2 mb-2 sticky-top smooth-scroll"
                        >
                          <ul className="nav nav-tabs">
                            <li className="nav-item">
                              {" "}
                              <a
                                className="nav-link active text-nowrap"
                                href="#known-for"
                              >
                                Information
                              </a>{" "}
                            </li>
                            <li className="nav-item">
                              {" "}
                              <a className="nav-link" href="#inclusions">
                                Inclusions
                              </a>{" "}
                            </li>
                            <li className="nav-item">
                              {" "}
                              <a className="nav-link" href="#exclusions">
                                Exclusion
                              </a>{" "}
                            </li>
                            <li className="nav-item">
                              {" "}
                              <a className="nav-link" href="#cancellations">
                                Cancellation
                              </a>{" "}
                            </li>
                            <li className="nav-item">
                              {" "}
                              <a className="nav-link" href="#itineraries">
                                Itinerary
                              </a>{" "}
                            </li>
                          </ul>
                        </nav>
                        <p id="known-for">{product.description}</p>
                        <div className="row">
                          <div className="col-12 col-sm-12">
                            <ol className="simple-ul">
                              {informations.length > 0 &&
                                informations.map((x) => (
                                  <li className="mb-2">{x.description}</li>
                                ))}
                            </ol>
                          </div>
                        </div>
                        <hr />
                        <div className="featured-box style-1">
                          <div className="featured-box-icon text-muted">
                            {" "}
                            <i className="far fa-comments" />
                          </div>
                          <h4 className="fw-400 text-4 mb-1">Staff Speaks</h4>
                          <p>English</p>
                        </div>
                        {/* Known For end */}
                        <hr className="mb-4" />
                        <h4 id="inclusions" className="text-6 mb-4 mt-2">
                          Inclusions
                        </h4>
                        <div className="row">
                          <div className="col-12 col-sm-12">
                            <ol className="simple-ul">
                              {inclusions.length > 0 &&
                                inclusions.map((x) => (
                                  <li className="mb-2">{x.description}</li>
                                ))}
                            </ol>
                          </div>
                        </div>
                        <hr className="mb-4" />
                        <h4 id="exclusions" className="text-6 mb-4 mt-2">
                          Exclusions
                        </h4>
                        <div className="row">
                          <div className="col-12 col-sm-12">
                            <ol className="simple-ul">
                              {exclusions.length > 0 &&
                                exclusions.map((x) => (
                                  <li className="mb-2">{x.description}</li>
                                ))}
                            </ol>
                          </div>
                        </div>
                        <hr className="mb-4" />
                        <h4 id="cancellations" className="text-6 mb-4 mt-2">
                          Cancellation
                        </h4>
                        <div className="row">
                          <div className="col-12 col-sm-12">
                            <p className="mb-2">{cancellations.description}</p>
                          </div>
                        </div>
                        <hr className="mb-4" />
                        <h4 id="itineraries" className="text-6 mb-4 mt-2">
                          Itinerary
                        </h4>
                        <div className="row">
                          <div className="col-12 col-sm-12">
                            <ol className="simple-ul">
                              {itineraries.length > 0 &&
                                itineraries.map((x) => (
                                  <li className="mb-2">{x.description}</li>
                                ))}
                            </ol>
                          </div>
                        </div>
                      </div>
                    </div>
                    <aside className="col-lg-4 mt-4 mt-lg-0">
                      <div className="side-block card rounded-2 p-3">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <h5 className="fw-semibold fs-6 mb-0">
                            Payment Summary
                          </h5>
                        </div>
                        <div className="card mb-4 mt-lg-0 mt-4">
                          <div className="card-body py-2">
                            <div className="price-summary">
                              <ul className="list-unstyled">
                                <li className="mb-2 fw-500">
                                  Destination
                                  <span className="float-end text-4 fw-500 text-dark">
                                    {searchQuery?.destination}
                                  </span>
                                </li>
                                <li className="mb-2 fw-500">
                                  Travel Date
                                  <span className="float-end text-4 fw-500 text-dark">
                                    {searchQuery?.travelDate}
                                  </span>
                                </li>
                                <li className="mb-2 fw-500">
                                  Total Adults
                                  <span className="float-end text-4 fw-500 text-dark">
                                    {searchQuery?.adults}
                                  </span>
                                </li>
                                <li className="mb-2 fw-500">
                                  Total Kids
                                  <span className="float-end text-4 fw-500 text-dark">
                                    {searchQuery?.kids}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="card-footer bg-white border-top py-3">
                            <div className="d-flex align-items-center justify-content-between">
                              <p className="fw-semibold text-muted-2 mb-0">
                                Total Price
                              </p>
                              <p className="fw-semibold text-primary mb-0">
                                INR{" "}
                                {Math.round(
                                  (parseInt(searchQuery.adults) +
                                    parseInt(searchQuery.kids)) *
                                    parseFloat(productQuery.salePrice)
                                )}
                              </p>
                            </div>
                            <div className="d-grid mt-2">
                              <button
                                className="btn btn-primary"
                                type="submit"
                                onClick={() => handleBook()}
                              >
                                Book Now
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </aside>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SightSeeingProduct;
